// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_j6-0";
export var actionModalContentContainer = "_j6-1";
export var createTagButton = "_j6-2";
export var footerContainer = "_j6-7";
export var fullWidthDivider = "_j6-3";
export var hasCreateTagButton = "_j6-4";
export var noCreateTagButton = "_j6-5";
export var tagsContainer = "_j6-6";
export var tagsModalContentContainer = "_j6-8";